import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import MyButton from '../../../../../shared-components/button/Button';
import CustomInput from '../../../../../shared-components/custom-input/CustomInput';
import SelectField from '../../../../../shared-components/select-field/SelectField';

interface ChargingPointOverview {
  boxId: string;
  heartbeat: string | number;
  description: string;
  note: string;
  version: string | number;
}

/**
 * Charging point overview
 * @returns {any} The result
 */
export default function DataManagement() {
  const { t } = useTranslation('devices');
  const [chargingPointData, setChargingPointData] = useState<ChargingPointOverview>({
    boxId: '',
    heartbeat: 0,
    description: '',
    note: '',
    version: '',
  });

  /**
   * Handle the change function
   * @param {any} name - The name
   * @param {any} value - The value
   * @returns {any} The result
   */
  const handleChangeFunction = (name: string, value: string[] | File[] | string | number) => {
    setChargingPointData((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  return (
    <div className="ocpp-console-data-management-wrap">
      <div>{t('tabsHere')}</div>
      <div className="ocpp-console-data-management-container">
        <h2>{t('chargePointOverview')}</h2>
        <div className="data-management-form">
          <CustomInput
            name="boxId"
            inputLabel={t('chargeBoxID')}
            type="text"
            placeholder={t('enterChargeID')}
            value={chargingPointData.boxId}
            onChangeValue={handleChangeFunction}
            fontSize="small"
          />
          <SelectField
            name="heartbeat"
            inputLabel={t('heartBeatPeriod')}
            selectedValue={chargingPointData.heartbeat}
            placeholder={t('enterHeartBeatPeriod')}
            onChangeValue={handleChangeFunction}
            options={[]}
            fontSize="small"
          />
          <CustomInput
            name="description"
            inputLabel={t('description')}
            type="text"
            placeholder={t('enterDescription')}
            value={chargingPointData.description}
            onChangeValue={handleChangeFunction}
            fontSize="small"
          />
          <CustomInput
            name="note"
            inputLabel={t('note')}
            type="text"
            placeholder={t('enterNote')}
            value={chargingPointData.note}
            onChangeValue={handleChangeFunction}
            fontSize="small"
          />
          <SelectField
            name="version"
            inputLabel={t('oCPPVersion')}
            selectedValue={chargingPointData.version}
            placeholder={t('enterVersion')}
            onChangeValue={handleChangeFunction}
            options={[]}
            fontSize="small"
          />
        </div>
        <div className="data-management-form-buttons">
          <MyButton label={t('back')} buttonType="back" onClickFunc={() => {}} />
          <MyButton
            label={t('submit')}
            buttonType="submit"
            loading={false}
            disableButton={false}
            onClickFunc={() => {}}
          />
        </div>
      </div>
    </div>
  );
}
